import React from 'react';

import { Divider } from '@rbilabs/universal-components';

import { EnvPicker } from 'components/env-picker';
import { allowEnvPicker, env, region } from 'utils/environment';

import { HiddenSection } from '../components';

import { InternalDiagnostics } from './internal-diagnostics';
import { PublicDiagnostics } from './public-diagnostics';

export const Configs = () => {
  return (
    <>
      <PublicDiagnostics />

      {allowEnvPicker && (
        <>
          <Divider />
          <HiddenSection
            title={`Env Config (current: ${env()}, ${region})`}
            content={<EnvPicker isDiagnosticsScreen />}
          />
        </>
      )}
      <Divider />

      <InternalDiagnostics />
    </>
  );
};
